import React from 'react';
export function ExperienceSection() {
  const experiences = [{
    id: 1,
    role: 'Robotics Instructor (BattleBots)',
    company: 'iD Tech Camps',
    period: 'Jun 2025 – Aug 2025',
    description: ['Taught mechanical design, VEX robotics, and C++ programming', 'Led daily engineering challenges and weekly BattleBots tournaments', 'Managed inventory across multiple campuses'],
    image: 'https://images.unsplash.com/photo-1535378917042-10a22c95931a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80'
  }, {
    id: 2,
    role: 'Entrepreneur',
    company: 'E.S.I (Entrepreneur & Startup Incubator)',
    period: 'Jul 2025 – Present',
    description: ['Building and launching startup apps', 'Co-founding hardware + AI startups', 'Won Y Combinator AI Agents Hackathon'],
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80'
  }, {
    id: 3,
    role: 'Marketing Officer',
    company: 'UCSC Startup Club',
    period: '2024 – Present',
    description: ['Led rebranding of SCEE into Startup Club', 'Managing Instagram presence, creating posts, designing flyers', 'Running startup bootcamp with pitch events and mentorship'],
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 4,
    role: 'ITS Service Desk Technician',
    company: 'UC Santa Cruz',
    period: '2024 – Present',
    description: ['Ticket triage, call routing, issue resolution using ServiceNow', 'Supporting teams at UC Santa Cruz'],
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1776&q=80'
  }];
  return <section id="experience" className="section-spacing bg-background-light" data-id="element-28">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-29">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-30">
          Work Experience
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-31">
          Professional roles and responsibilities in technology and education
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-32">
          {experiences.map(exp => <div key={exp.id} className="card overflow-hidden hover:translate-y-[-5px]" data-id="element-33">
              <div className="flex flex-col md:flex-row" data-id="element-34">
                <div className="md:w-1/3 aspect-square md:aspect-auto" data-id="element-35">
                  <img src={exp.image} alt={exp.company} className="w-full h-full object-cover" data-id="element-36" />
                </div>
                <div className="p-6 md:w-2/3" data-id="element-37">
                  <h3 className="text-xl font-display font-bold mb-1" data-id="element-38">
                    {exp.role}
                  </h3>
                  <p className="text-primary mb-2" data-id="element-39">{exp.company}</p>
                  <p className="text-text-secondary mb-4" data-id="element-40">{exp.period}</p>
                  <ul className="list-disc pl-5 text-text-secondary" data-id="element-41">
                    {exp.description.map((item, index) => <li key={index} className="mb-1" data-id="element-42">
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}